const ruleData = {
  desc1: ["本版本最近更新日期：2022年02月。"],
  desc2: [
          "请用户在使用本公司的产品或服务前，仔细阅读并了解本《个人信息保护政策》。",
          "如果用户有任何疑问、意见或建议，请通过以下联系方式与本公司联系：",
          "上海野派电子商务有限公司（“野兽派”APP运营方）",
          "注册地址：上海市虹口区欧阳路196号10号楼9层20室",
          "电子邮件： service@thebeastshop.com",
          "电 话：400-9200-108"
        ],
  stress: {
    title: "本政策将帮助用户了解以下内容：",
    items: [
      "一、如何收集和使用用户的个人信息",
      "二、如何使用Cookie和同类技术",
      "三、网站信标和像素标签",
      "四、个人信息的管理与保护",
      "五、如何共享、转让、公开披露用户的个人信息",
      "六、个人信息的跨境传输",
      "七、用户权限",
      "八、如何处理未成年人的个人信息",
      "九、当用户向本公司提供第三方数据",
      "十、本政策如何更新",
      "十一、如何联系本公司"
    ]
  },
  desc3: [
    "野兽派（以下称“本公司”）深知个人信息对用户的重要性，并会尽全力保护用户的个人信息安全可靠。本公司致力于维持用户对本公司的信任，恪守以下原则，保护用户的个人信息：权责一致原则、目的明确原则、选择同意原则、最小必要原则、确保安全原则、主体参与原则、公开透明原则等。同时，本公司承诺，本公司将按业界成熟的安全标准，采取相应的安全保护措施来保护用户的个人信息。"
  ],
  contents: [
    {
      title: "一、如何收集和使用用户的个人信息",
      items: [
        {
          itemTitle: "1.个人信息的定义",
          itemList: [
            {
              listTitle: "“个人信息”即“公民个人信息”，是指以电子或者其他方式记录的能够单独或者与其他信息结合识别特定自然人身份或者反映特定自然人活动情况的各种信息。 ",
            }
          ]
        },
        {
          itemTitle: "2.本公司收集的个人信息",
          itemList: [
            {
              listTitle: "在用户访问野兽派旗下门店、网站（包括野兽派官方网站、野兽派各平台旗舰店）、社交媒体平台（包括野兽派旗下微信公众号、野兽派旗下微博官方账号，以及其他本公司使用的、为用户提供各类服务的社交媒体平台）、手机应用程序野兽派APP（以下可简称“APP”）、野兽派微信小程序时，本公司可能会收集用户的个人信息，包括："
            },
            {
              listTitle: "（1）本公司提供的下述业务功能需要依赖部分信息才得以运行：",
              listItems: [
                "· 用户注册本公司的会员时：为验证用户身份、识别用户，需要收集用户的姓名、性别、联络方式（手机号码、电子邮件，或由用户提供的其他联络信息）、微信账号、微博账号、QQ账号、邮箱账号或用户同意提供的其他第三方平台账号相关信息。如果用户不提供上述部分或全部信息，可能会无法注册为本公司的会员。",
                "· 用户购买本公司非跨境类商品或使用本公司提供的非跨境类服务时：为了完成订单支付及完成后续配送服务，本公司可能会收集用户的姓名、联系方式（电话号码或由用户提供的其他联络信息）、配送地址、用户的第三方平台账号信息、用户的支付方式（支付宝、微信）相关信息。如果用户不提供这些信息，可能会无法成功购买本公司商品或使用本公司提供的服务。",
                "· 用户购买本公司跨境类商品或使用本公司提供的跨境类服务时：除上述购买非跨境类商品或使用非跨境类服务需要提供的信息外，用户另需提供实名认证的个人信息（真实姓名、用户身份证号）。如果用户不提供上述信息，会导致无法购买本公司跨境类商品或无法使用本公司提供的跨境类服务。",
                "· 用户分享APP页面至微信客户端/从APP链接至微信小程序时：本公司可能会收集用户的手机软件安装列表，用以实现分享和跳转功能。如果用户不提供上述信息，可能会导致无法分享APP页面至微信客户端/无法通过APP链接跳转至微信小程序。"
              ]
            },
            {
              listTitle: "（2）用户可自主选择向本公司提供或允许本公司收集下列信息：",
              listItems: [
                "· 用户参加本公司举办的各类促销/体验活动时：本公司可能会收集用户的姓名、性别、出生日期、具体住址、联系方式（手机号码、微信账号，或由用户提供的其他联络信息）、照片、第三方平台账号相关信息。届时本公司将针对特定促销/体验活动另行取得用户授权同意。如果用户不提供上述信息，可能会导致无法参加促销/体验活动或获得相应的礼品或活动限定折扣。",
                "举例：本公司将于注册为会员的用户每年生日期间于本公司线上或线下渠道（具体视本公司会员政策及每年活动公告而定）向该用户提供免费生日礼一份，如用户拒绝向本公司提供生日信息，则无法获得前述会员生日礼。",
                "· 本公司提供账号验证或营销信息推送服务时：本公司可能会预先收集用户的联系方式（手机号码、微信账号），用来提供账号验证服务，或营销信息推送服务。如果用户不提供上述信息，可能会导致无法获得与前述联系方式绑定的账号验证，或会导致无法通过前述联系方式获得本公司提供的免费营销信息推送服务。"
              ]
            },
            {
              listTitle: "（3）在用户使用下述业务功能时，本公司的App会向用户申请下列与个人信息相关的系统权限：",
              listItems: [
                "· 用户进行订单评价时：如用户申请对已完成订单进行拍照附图或相册传图的方式评价以获取积分，则本公司的App会向用户申请用户移动设备的摄像头及/或相册系统权限（以用户评价时的自主选择为依据发出权限许可请求），如果用户不主动进行系统权限授权，将会导致本公司无法提供评价的业务功能。",
                "· 用户进行订单评价时：如用户申请对已完成订单进行拍照附图或相册传图的方式评价以获取积分，则本公司的App会向用户申请用户移动设备的摄像头及/或相册系统权限（以用户评价时的自主选择为依据发出权限许可请求），如果用户不主动进行系统权限授权，将会导致本公司无法提供评价的业务功能。",
                "· 用户查找最近门店时：如用户申请查找本公司距离最近的门店，则本公司的APP会向用户申请移动设备的定位信息。如果用户不主动进行系统权限授权，将会导致本公司无法提供该项服务。",
                "· 用户使用语音祝福卡功能时：如用户申请使用语音祝福卡功能，则本公司的APP会向用户申请移动设备的麦克风授权。如果用户不主动进行系统权限授权，将会导致本公司无法提供该项服务。",
                "除上述系统权限之外，用户可自主选择是否额外授予App其他的系统权限。"
              ]
            },
            {
              listTitle: "（4）除上述个人信息之外，在此后的业务发展进程中，App可能会基于改善服务质量、研发新产品或服务的目的向用户收集其他个人信息，届时。用户可自主选择是否额外提供App其他的个人信息。这些信息并非该业务功能运行所必需，本公司不会强制要求用户提供这些信息，用户如拒绝提供不会对使用核心业务功能（浏览App、通过App下单本公的商品等服务）产生不利影响，具体后果及影响本公司将于收集个人信息时同步告知。"
            }
          ]
        },
        {
          itemTitle: "3.从第三方收集个人信息",
          itemList: [
            {
              listTitle: "本公司可能从第三方收集用户的个人信息。比如，用户通过第三方平台购买本公司的商品或服务，为完成订单，本公司将会从第三方平台收集所需的用户个人信息；本公司通过第三方（包括向本公司提供软件开发、技术支持、数据分析、活动统筹或管理业务的主体）向用户提供服务的，本公司将从该第三方收集用户同意提供的个人信息。目前可收集用户信息的第三方平台及收集目的：",
            },
            {
              listTitle: "(1)微信平台（主动授权），用于第三方登录；"
            },
            {
              listTitle: "(2)QQ平台（主动授权），用于第三方登录；"
            },
            {
              listTitle: "(3)微博平台（主动授权），用于第三方登录。"
            }
          ]
        },
        {
          itemTitle: "4.个人信息的使用",
          itemList: [
            {
              listTitle: "本公司对于收集得来的用户个人信息，将用于以下目的：",
            },
            {
              listTitle: "（1）为用户提供本公司旗下品牌商品和相关服务；",
            },
            {
              listTitle: "（2）为用户提供本公司旗下品牌商品和服务的相关信息；",
            },
            {
              listTitle: "（3）为提升本公司的商品及服务质量；",
            },
            {
              listTitle: "（4）为其他相关法律允许的正当目的。",
            },
            {
              listTitle: "此外，在使用用户个人信息时有必要超出本政策既定的使用目的或范围的，本公司将另行取得用户的明示同意。"
            }
          ]
        }
      ]
    },
    {
      title: "二、如何使用Cookie和同类技术",
      stress: "Cookie",
      items: [
        {
          itemTitle: "",
          itemList: [
            {
              listTitle: "为确保网站或APP正常运转，本公司会在用户的计算机或移动设备上存储名为 Cookie 的小数据文件。Cookie 通常包含标识符、站点名称以及一些号码和字符。借助于 Cookie，网站或APP能够存储用户的偏好或购物车内的商品相关数据。 Cookie具体作用如下："
            },
            {
              listTitle: "（1）用于保持用户的登录状态；"
            },
            {
              listTitle: "（2）用于app读取登录用户的基本信息（会员号，姓名，积分等）；"
            },
            {
              listTitle: "（3） 用户打开app的时长（AOS广告投放监测）；"
            },
            {
              listTitle: "（4）页面访问路径，用于改善app使用体验（包括页面浏览路径、按钮点击行为、用户收藏下单等行为）。",
              listItems: [
                "本公司不会将 Cookie 用于本政策所述目的之外的任何用途。用户可根据自己的偏好及相应浏览器自主管理或删除 Cookie，删除方式如下：",
                "· <internet Explorer>浏览器",
                "删除链接：https://support.microsoft.com/zh-cn/help/17442/windows-internet-explorer-delete-manage-cookies",
                "· <google Chrome>浏览器",
                "删除链接：https://support.google.com/chrome/answer/95647",
                "· <safari>浏览器 删除链接：",
                "https://support.apple.com/kb/PH19214?locale=zh_CN",
                "· <mozilla Firefox>浏览器 ",
                "删除链接：https://support.mozilla.org/en-US/kb/cookies-information-websites-store-on-your-computer?redirectlocale=en-US&redirectslug=Cookies",
                "用户可以清除计算机上保存的所有 Cookie，大部分网络浏览器都设有阻止 Cookie 的功能。但如果用户这么做，则需要在每一次访问本公司的网站时亲自更改用户设置。 ",
                "另外，本公司的Cookie也设有自动清理缓存机制，目前本公司保存Cookie的期间为六个月，自Cookie生成之日起六个月后将自动清理失效。",
              ]
            }
          ]
        }
      ]
    },
    {
      title: "三、网站信标和像素标签",
      items: [
        {
          itemTitle: "",
          itemList: [
            {
              listTitle: "除 Cookie 外，为了更好地提供服务，本公司还会在网站或APP上使用网站信标和像素标签或其他同类技术。举例来说，本公司向用户发送的电子邮件可能含有链接至本公司相关网站内容的URL链接，如果用户点击该链接，本公司则会跟踪此次点击，帮助本公司了解用户的商品或服务偏好并改善客户服务。网站信标通常是一种嵌入到网站或电子邮件中的透明图像。借助于电子邮件中的像素标签，本公司能够获知电子邮件是否被打开。如果用户不希望自己的活动以这种方式被追踪，则可以随时从本公司的寄信名单中退订。",
            }
          ]
        }
      ]
    },
    {
      title: "四、个人信息的管理与保护",
      items: [
        {
          itemTitle: "1. 本公司将严格遵守中华人民共和国的有关法律、法规的规定，采取必要而适当的安全技术措施，使用符合业界标准的安全防护措施保护用户提供的个人信息，防止数据遭到未经授权访问、公开披露、使用、修改、损坏或丢失。本公司会采取一切合理可行的措施，保护用户的个人信息。例如：",
          itemList: [
            {
              listTitle: "（1）本公司会采用符合业界标准的安全防护措施，包括建立合理的制度规范、安全技术来防止用户的个人信息遭到未经授权的访问使用、修改,避免数据的损坏或丢失。",
            },
            {
              listTitle: "（2）本公司的网络服务采取了传输层安全协议等加密技术，通过https等方式提供浏览服务，确保用户数据在传输过程中的安全。",
            },
            {
              listTitle: "（3）本公司采取加密技术对用户个人信息进行加密保存，包括SHA256，MD5等技术，并通过隔离技术进行隔离。",
            },
            {
              listTitle: "（4）本公司采用严格的数据访问权限控制和多重身份认证技术保护个人信息，避免数据被违规使用。"
            }
          ]
        },
        {
          itemTitle: "2. 就用户向本公司提供的个人信息，除本政策“第六条个人信息的跨境传输”约定的内容外，本公司将个人信息保存于中国境内。就上述数据的保存期限、处理方式等，本公司也将严格按照相关法律、法规的规定执行。如无法律允许的特殊情况，本公司通常会将该等数据保存至用户注销账户。",
        },
        {
          itemTitle: "3. 本公司会采取一切合理可行的措施，确保未收集无关的个人信息。本公司只会在达成本政策所述目的所需的期限内保留用户的个人信息，除非需要延长保留期或受到法律的允许。",
        },
        {
          itemTitle: "4. 本公司将根据需要，不定期更新并公开安全风险、个人信息安全影响评估等报告的有关内容。",
        },
        {
          itemTitle: "5. 互联网环境并非百分之百安全，本公司将尽力确保或担保用户发送给本公司的任何信息的安全性。如果本公司的物理、技术、或管理防护设施遭到破坏，导致信息被非授权访问、公开披露、篡改、或毁坏，导致用户的合法权益受损，本公司将承担相应的法律责任。",
        },
        {
          itemTitle: "6. 在不幸发生个人信息安全事件后，本公司将按照法律法规的要求，及时向用户告知：安全事件的基本情况和可能的影响、本公司已采取或将要采取的处置措施、用户可自主防范和降低风险的建议、对用户的补救措施等。本公司将及时将事件相关情况以邮件、信函、电话、推送通知等方式告知用户，难以逐一告知个人信息主体时，本公司会采取合理、有效的方式发布公告。 同时，本公司还将按照监管部门要求，主动上报个人信息安全事件的处置情况。 "
        }
      ]
    },
    {
      title: "五、如何委托处理、共享、转让、公开披露用户的个人信息",
      items: [
        {
          itemTitle: "1. 委托处理 ",
          itemList: [
            {
              listTitle: "本业务功能中某些具体的模块或功能须由外部供应商提供协助。例如本公司会聘请服务提供商来协助本公司提供客户支持、聘请服务提供商来协助本公司进行用户个人真实信息的核实（仅适用于用户购买跨境商品的情形）。",
              listItems: [
                "对本公司委托处理个人信息的公司、组织和个人，其应有提供相应服务的完整资质，且本公司会与其签署严格的保密协定或于相关服务合同中嵌入保密条款，并要求他们按照本公司的要求、本政策以及其他任何相关的保密和安全法律法规及安全措施来处理个人信息。"
              ]
            }
          ]
        },
        {
          itemTitle: "2. 共享",
          itemList: [
            {
              listTitle: "通常情况下，本公司不会与本公司以外的任何公司、组织和个人分享用户的个人信息，除非获得用户的明确同意。目前，本公司会在以下情形中，向用户征求用户对共享个人信息的授权同意：",
            },
            {
              listTitle: "（1）为了业务的管理以及提升服务水平，本公司可能会与本公司的关联公司（包括本公司的母公司、本公司的母公司直接或间接持股50%以上的公司，以下亦同）共享用户提供的所有个人信息。"
            },
            {
              listTitle: "（2）为了完成用户与本公司发生的商品或服务交易、为用户提供完善的售后服务、信息服务以及其他相关服务、提升用户的服务使用体验，本公司可能会在必要的限度内向本公司的供应商（包括物流公司、支付平台、通知推送平台、向本公司提供软件开发、技术支持、数据分析、活动统筹或管理业务的主体）提供与上述服务有关的用户的个人信息。例如，本公司会向物流公司共享用户提供的收件人姓名、收件地址及联系电话信息，向支付平台共享用户的交易单号及交易金额信息。"
            },
            {
              listTitle: "（3）为了完成用户与本公司发生的商品或服务交易、为用户提供完善的售后服务、信息服务以及其他相关服务、提升用户的服务使用体验，本公司可能会在必要的限度内向我们的供应商（包括物流公司、支付平台、售后客服平台、通知推送平台、向本公司提供软件开发、技术支持、数据分析、活动统筹或管理业务的主体）提供与服务有关的用户的个人信息。本公司产品嵌入第三方供应商代码、接口、插件等的情形包括："
            },
            {
              listTable: "用html填充",
            },
            {
              listTitle: "本公司可能会根据法律法规规定，或按政府主管部门的强制性要求，对外共享用户的个人信息。"
            }
          ]
        },
        {
          itemTitle: "3. 转让",
          itemList: [
            {
              listTitle: "本公司不会将用户的个人信息转让给任何公司、组织和个人，但以下情形除外：",
              listItems: [
                "a) 在获取明确同意的情况下转让：获得用户的明确同意后，本公司会向其他方转让用户的个人信息；",
                "b) 在涉及合并、收购或破产清算时，如涉及到个人信息转让，本公司会在要求新的持有用户个人信息的公司、组织继续受此个人信息保护政策的约束，否则本公司将要求该公司、组织重新向用户征求授权同意。"
              ]
            }
          ]
        },
        {
          itemTitle: "4. 公开披露",
          itemList: [
            {
              listTitle: "本公司仅会在以下情形下，公开披露用户的个人信息： ",
              listItems: [
                "a) 获得用户明确同意后； ",
                "b) 基于法律的披露：在法律、法律程序、诉讼或政府主管部门强制性要求的情况下，本公司可能会公开披露用户的个人信息。"
              ]
            }
          ]
        }
      ]
    },
    {
      title: "六、个人信息的跨境传输",
      items: [
        {
          itemList: [
            {
              listTitle: "原则上，本公司在中华人民共和国大陆地区内收集和产生的个人信息，并将该等个人信息存储在中华人民共和国大陆地区内。",
              listItems: [
                "为了提升本公司品牌对用户的服务质量提供跨境海淘等服务项目，本公司可能会将用户提供的所有个人信息提供给本公司的境外的关联公司或跨境电子商务中的合作公司，这意味着，在获得用户的授权同意后，用户的个人信息可能会被转移到用户使用产品或服务所在国家/地区的境外管辖区，或者受到来自这些管辖区的访问。（目前接受个人信息跨境传输的主体公司THEBEASTSHOP HK LIMITED，如有新增主体，本公司将实时更新个人信息保护政策，并获得用户的明示同意。具体跨境电子商务政策请点击：《野兽派海外产品购物协议》https://www.thebeastshop.com/static/oversea-qa）",
                "在进行上述个人信息跨境传输的过程中，本公司将遵守相关法律法规的要求，在跨境传输前依法开展数据出境安全评估，并尽最大的可能对个人信息进行匿名化处理或去标识化处理，以保护用户的个人信息安全。"
              ]
            }
          ]
        }
      ]
    },
    {
      title: "七、用户权限",
      items: [
        {
          itemList: [
            {
              listTitle: "按照中国相关的法律、法规、标准，以及其他国家、地区的通行做法，本公司保障用户对自己的个人信息行使以下权利："
            }
          ]
        },
        {
          itemTitle: "1. 访问用户的个人信息 ",
          itemList: [
            {
              listTitle: "用户有权访问用户的个人信息，法律法规规定的例外情况除外。如果用户想行使数据访问权，可以通过以下方式自行访问：",
              listItems: [
                "· 会员注册信息及身份验证信息——如果用户希望访问用户的会员注册信息中的个人资料信息，身份验证信息，登录密码等，用户可以访问本公司官网，APP和小程序个人中心模块执行此类访问操作。搜索信息——用户可以在公司官网，APP和小程序中访问搜索历史记录。",
                "· 搜索信息——用户可以在本公司官网，APP和小程序中访问搜索历史记录。",
                "· 订单记录——用户可以在本公司官网，APP和小程序中订单详情模块访问订单记录。",
                "如果用户无法通过上述链接访问这些个人信息，用户可联系本公司进行提供，联系方式参见本政策第十一条。 本公司将在十五个工作日内回复用户的访问请求。",
                "对于用户在使用本公司的产品或服务过程中产生的其他个人信息，只要本公司不需要过多投入，本公司会向用户提供。如果用户想行使数据访问权，可联系本公司进行提供，联系方式参见本政策第十一条。"
              ]
            }
          ]
        },
        {
          itemTitle: "2. 更正用户的个人信息",
          itemList: [
            {
              listTitle: "当用户发现本公司处理的关于用户的个人信息有错误时，用户有权要求本公司进行更正。用户可以通过以下方式更正个人信息：",
              listItems: [
                "· 会员注册信息及身份验证信息——如果用户希望更改用户的会员注册信息中的个人资料信息、身份验证信息、登录密码等，用户可以访问本公司官网，野兽派APP和小程序个人中心模块执行此类操作。",
                "· 搜索信息——用户可以在公司官网，APP和小程序中删除搜索历史记录。",
                "· 订单记录——用户可以在公司官网，APP和小程序中订单详情模块删除订单记录。",
                "如果用户无法通过上述方法更正这些个人信息，用户可以随时联系本公司进行更正，联系方式参见本政策第十一条本公司将在十五个工作日内回复用户的更正请求。"
              ]
            },
          ]
        },
        {
          itemTitle: "3. 删除用户的个人信息",
          itemList: [
            {
              listTitle: "在以下情形中，用户可以向本公司提出删除个人信息的请求："
            },
            {
              listTitle: "（1）如果本公司处理个人信息的行为违反法律法规；"
            },
            {
              listTitle: "（2）如果本公司收集、使用用户的个人信息，却未征得用户的同意；"
            },
            {
              listTitle: "（3）如果本公司处理个人信息的行为违反了与用户的约定；"
            },
            {
              listTitle: "（4）如果用户不再使用本公司的产品或服务，或用户注销了账号；"
            },
            {
              listTitle: "（5）如果本公司不再为用户提供产品或服务。"
            },
            {
              listTitle: "若本公司决定响应用户的删除请求，本公司还将同时通知从本公司获得用户的个人信息的实体，要求其及时删除，除非法律法规另有规定，或这些实体非通过本公司而独立获得用户的单独授权。",
              listItems: [
                "当用户从本公司的服务中删除信息后，本公司可能不会立即在备份系统中删除相应的信息，但会在备份更新时删除这些信息。"
              ]
            },
          ]
        },
        {
          itemTitle: "4. 改变用户授权同意的范围",
          itemList: [
            {
              listTitle: "每个业务功能需要一些基本的个人信息才能得以完成。对于额外收集的个人信息的收集和使用，用户可以联系本公司随时给予或收回授权同意，联系方式参见本政策第十一条。",
              listItems: [
                "当用户收回同意后，本公司将不再处理相应的个人信息。但用户收回同意的决定，不会影响此前基于用户的授权而开展的个人信息处理。",
                "如果用户不想接受本公司给用户发送的商业广告，用户随时可通过以下方式取消：",
                "· 野兽派APP推送/弹窗消息——用户可以在手机上设置不接受此类推送/弹窗消息;",
                "· 短信——用户可以在短信中选择退订;",
                "· 微信服务号推送消息——用户可以取消关注服务号。"
              ]
            },
          ]
        },
        {
          itemTitle: "5. 个人信息主体注销账户",
          itemList: [
            {
              listTitle: "用户可以在野兽派APP及小程序的个人中心模块随时注销此前注册的账户。",
              listItems: [
                "在注销账户之后，本公司将停止为用户提供产品或服务，并依据用户的要求，删除用户的个人信息，法律法规另有规定的除外。"
              ]
            },
          ]
        },
        {
          itemTitle: "6. 个人信息主体获取个人信息副本",
          itemList: [
            {
              listTitle: "用户有权联系本公司获取用户的个人信息副本，联系方式参见本政策第十一条。",
              listItems: [
                "在技术可行的前提下，如数据接口已匹配，本公司还可按用户的要求，直接将用户的个人信息副本传输给用户指定的第三方。"
              ]
            },
          ]
        },
        {
          itemList: "7. 约束信息系统自动决策",
          itemList: [
            {
              listTitle: "在某些业务功能中，本公司可能仅依据信息系统、算法等在内的非人工自动决策机制作出决定。如果这些决定显著影响用户的合法权益，用户有权要求本公司作出解释，本公司也将提供适当的救济方式。"
            },
          ]
        },
        {
          itemTitle: "8. 响应用户的上述请求",
          itemList: [
            {
              listTitle: "为保障安全，用户可能需要提供书面请求，或以其他方式证明用户的身份。本公司可能会先要求用户验证自己的身份，然后再处理用户的请求。",
              listItems: [
                "本公司将在十五个工作日内作出答复。如用户不满意，还可以联系本公司进行投诉，联系方式参见本政策第十一条。",
                "对于用户合理的请求，本公司原则上不收取费用，但对多次重复、超出合理限度的请求，本公司将视情收取一定成本费用。对于那些无端重复、需要过多技术手段（例如，需要开发新系统或从根本上改变现行惯例等）、给他人合法权益带来风险或者非常不切实际（例如，涉及备份磁带上存放的信息）的请求，本公司可能会予以拒绝。",
                "在以下情形中，本公司将无法响应用户的请求："
              ]
            },
            {
              listTitle: "（1）与个人信息控制者履行法律法规规定的义务相关的；"
            },
            {
              listTitle: "（2）与国家安全、国防安全直接相关的；"
            },
            {
              listTitle: "（3）与公共安全、公共卫生、重大公共利益直接相关的；"
            },
            {
              listTitle: "（4）与刑事侦查、起诉、审判和执行判决等直接相关的；"
            },
            {
              listTitle: "（5）个人信息控制者有充分证据表明个人信息主体存在主观恶意或滥用权利的；"
            },
            {
              listTitle: "（6）出于维护个人信息主体或其他个人的生命、财产等重大合法权益但又很难得到本人同意的；"
            },
            {
              listTitle: "（7）响应个人信息主体的请求将导致个人信息主体或其他个人、组织的合法权益受到严重损害的；"
            },
            {
              listTitle: "（8）涉及商业秘密的。"
            }
          ]
        }
      ]
    },
    {
      title: "八、如何处理未成年人的个人信息",
      items: [
        {
          itemList: [
            {
              listTitle: "本公司的产品、网站和服务主要面向成年人。如果没有父母或监护人的同意，未成年人不应创建自己的个人信息主体账户。 ",
              listItems: [
                "未成年人如创建自己的个人信息主体账户并成为本公司会员，请在征得父母或监护人同意之后，由父母或监护人代为注册。如果未成年人未经父母或监护人同意，但隐瞒未成年人身份注册成为本公司会员的，本公司将视其为成年人会员。如果该未成年人或其父母、监护人在之后要求本公司停止向该会员账号提供服务的，本公司将在核实相关情况后立即取消该会员资格、停止提供会员服务，并按照国家有关法律法规的规定删除该会员账号以及相关个人信息。",
                "对于经父母或监护人同意而收集未成年个人信息的情况，本公司只会在受到法律允许、父母或监护人同意或者保护未成年所必要的情况下使用或公开披露此信息。",
                "如果本公司发现在未事先获得可证实的父母同意的情况下收集了未成年人的个人信息，则会设法尽快删除相关数据。"
              ]
            }
          ]
        }
      ]
    },
    {
      title: "九、当用户向本公司提供第三方数据",
      items: [
        {
          itemList: [
            {
              listTitle: "在用户接受本公司所提供的功能和服务中，如果用户主动向本公司提供了第三方的个人数据、个人信息（例如购买本公司产品，下单赠送第三方时），用户需要确认用户处理第三方个人数据或个人信息的方式、目的、范围，应确保已于向本公司提供前已向前述信息主体的第三方进行了告知，且用户已经明确获得了第三方的正面同意。"
            }
          ]
        }
      ]
    },
    {
      title: "十、本政策如何更新",
      items: [
        {
          itemList: [
            {
              listTitle: "本公司的个人信息保护政策可能变更。",
              listItems: [
                "未经用户明确同意，本公司不会削减用户按照本政策所应享有的权利。本公司会在本页面上发布对本政策所做的任何变更。",
                "对于重大变更，本公司还会提供更为显著的通知（包括对于某些服务，本公司会通过电子邮件发送通知，说明个人信息保护政策的具体变更内容）。",
                "本政策所指的重大变更包括但不限于："
              ]
            },
            {
              listTitle: "1、本公司的服务模式发生重大变化。如处理个人信息的目的、处理的个人信息类型、个人信息的使用方式等；"
            },
            {
              listTitle: "2、本公司在所有权结构、组织架构等方面发生重大变化。如业务调整、破产并购等引起的所有者变更等；"
            },
            {
              listTitle: "3、个人信息共享、转让或公开披露的主要对象发生变化；"
            },
            {
              listTitle: "4、用户参与个人信息处理方面的权利及其行使方式发生重大变化；"
            },
            {
              listTitle: "5、本公司负责处理个人信息安全的责任部门、联络方式及投诉渠道发生变化时；"
            },
            {
              listTitle: "6、个人信息安全影响评估报告表明存在高风险时。"
            },
            {
              listTitle: "另外，本政策如有更新，本公司还会将本政策的旧版本存档，供用户查阅。"
            }
          ]
        }
      ]
    },
    {
      title: "十一、如何联系本公司",
      items: [
        {
          itemList: [
            {
              listTitle: "如果用户对本政策有任何疑问、意见或建议，用户可以在野兽派官网(www.thebeastshop.com)，野兽派APP和小程序联系人工客服，与个人信息保护相关负责人员获得联络。",
              listItems: [
                "一般情况下，本公司将在十五个工作日内回复。"
              ]
            }
          ]
        }
      ]
    },
  ],
}

export default ruleData



// WEBPACK FOOTER //
// ./static/app-rule/data.js